import {
  clear,
  createStore,
  del,
  delMany,
  entries as getEntries,
  get,
  getMany,
  keys as getKeys,
  set,
  setMany,
  update,
  values as getValues,
} from 'idb-keyval';

import { PASSCODE_IDB_STORE_NAME } from '../../config';

class IdbStore {
  public store: ReturnType<typeof createStore>;

  constructor(name: string) {
    this.store = createStore(name, 'store');
  }

  public set(key: string, value: any) {
    return set(key, value, this.store);
  }

  public setMany(entries: [string, any][]) {
    return setMany(entries, this.store);
  }

  public get<T = unknown>(key: string) {
    return get<T>(key, this.store);
  }

  public getMany<T = unknown>(keys: string[]) {
    return getMany<T>(keys, this.store);
  }

  public clear() {
    return clear(this.store);
  }

  public del(key: string) {
    return del(key, this.store);
  }

  public delMany(keys: string[]) {
    return delMany(keys, this.store);
  }

  public entries() {
    return getEntries(this.store);
  }

  public keys() {
    return getKeys(this.store);
  }

  public values<T = unknown>() {
    return getValues<T>(this.store);
  }

  public update<T = unknown>(key: string, updater: (oldValue: T | undefined) => T) {
    return update(key, updater, this.store);
  }
}

export const MAIN_IDB_STORE = new IdbStore('tt-data');
// One database for the whole app: a single passcode covers every account, and each account's blobs
// are namespaced by slot inside it.
export const PASSCODE_IDB_STORE = new IdbStore(PASSCODE_IDB_STORE_NAME);
// Message history lives in its own database, one entry per chat, so a chat can be written or read on
// its own. Keeping it in `MAIN_IDB_STORE` would mean the single global-state blob grew with every
// chat kept — and that blob is rewritten in full on every cache tick.
export const MESSAGES_IDB_STORE = new IdbStore('tt-messages');
